import React from "react";
import { FastField } from "formik";


export default function PhoneInput(props) {
  // if object's path in form includes any objects
  const objectValuePath = (obj, string) => {
    let helper = obj
    string.split('.').map( i => helper = helper[i])
    return helper
    }
    
  const excludedSymbols = [
    // "e"
    69,
    // "."
    190,
    // "-"
    189
  ]
  return (
    <FastField name={props.name}>
      {({ field, form }) => {
        return (
          <label>
            <input className="no-arrow"
              type="number"
              onKeyDown={ e => ( excludedSymbols.includes(e.keyCode)) && e.preventDefault() }
              onChange={(e) => {
                form.setFieldValue(field.name, e.target.value);
                console.log(props.formik.values)
              }}
              value={props.formik.values[props.name] || objectValuePath(props.formik.values, props.name)}
            />
          </label>
        )
      }}
    </FastField>
  );
}


// WEBPACK FOOTER //
// ./src/modules/form/components/input/PhoneInput.jsx